import request from './request'

export function fetchInquiries (params = {}) {
  return request.get('/inquiries', { params })
}

export function updateInquiryStatus (id, status) {
  return request.put(`/inquiries/${id}/status`, { status })
}

export function fetchCustomRequests (params = {}) {
  return request.get('/custom-requests', { params })
}

export function updateCustomRequestStatus (id, status) {
  return request.put(`/custom-requests/${id}/status`, { status })
}
